// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import setRetailer from "@synd/App/Store/Pages/RetailerPriceManagement/Handlers/SetRetailer";
import * as React from "react";
import { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    setRetailer,
};

type Props = PageProps & ResolveThunks<typeof mapDispatchToProps>;

const RetailerPricingManagementPage: FC<Props> = ({ id, setRetailer }) => {
    useEffect(() => {
        return () => {
            // clear retailer value when unmount this page
            setRetailer({ retailer: undefined });
        };
    }, []);

    return (
        <>
            <Page data-test-selector="RetailerPricingManagementPage">
                <Zone contentId={id} zoneName="Content" />
            </Page>
            <Modals skipInventoryValidation={true} />
        </>
    );
};

const pageModule: PageModule = {
    component: connect(null, mapDispatchToProps)(RetailerPricingManagementPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RetailerPricingManagementPage" instead of this constant.
 */
export const RetailerPricingManagementPageContext = "RetailerPricingManagementPage";
